'use client';

import { alpha, styled } from '@mui/material/styles';
import SimpleBarReact from 'simplebar-react';

import type { SxProps } from '@mui/material';
import type { FC, PropsWithChildren } from 'react';
import type { Props as SimpleBarProps } from 'simplebar-react';

const RootStyle = styled( 'div' )(() => ({
  flexGrow: 1,
  height: '100%',
  overflow: 'hidden',
}));

const SimpleBarStyle = styled( SimpleBarReact )(({ theme }) => ({
  maxHeight: '100%',
  '& .simplebar-scrollbar': {
    '&:before': { backgroundColor: alpha( theme.palette.grey[600], 0.48 ) },
    '&.simplebar-visible:before': { opacity: 1 },
  },
  '& .simplebar-track.simplebar-vertical': { width: 10 },
  '& .simplebar-track.simplebar-horizontal .simplebar-scrollbar': { height: 6 },
  '& .simplebar-mask': { zIndex: 'inherit' },
}));

// ----------------------------------------------------------------------

interface ScrollbarProps extends SimpleBarProps {
  sx?: SxProps;
}

/**
 * A vertical Scrollbar disabled for mobile devices
 * @param children - to be wrapped
 * @param sx - style
 * @param props - rest Props
 */

export const Scrollbar: FC<PropsWithChildren<ScrollbarProps>> = (
  { children, sx = null, ...props } // const userAgent =
) => (
  //   typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent;
  //
  // const isMobile =
  //   /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/iu.test(
  //     userAgent
  //   );
  //
  // if (isMobile) {
  //   return (
  //     <Box
  //       sx={{
  //         overflowX: 'auto',
  //         ...sx,
  //       }}
  //       {...props}
  //     >
  //       {children}
  //     </Box>
  //   );
  // }

  <RootStyle>
    <SimpleBarStyle timeout={500} clickOnTrack={false} sx={sx} {...props}>
      {children}
    </SimpleBarStyle>
  </RootStyle>
);
